import Login from 'modules/user/pages/login';
import { Navigate } from 'react-router-dom';

export const authenticationRoutes = [
  {
    name: 'Authentication',
    route: '/login',
    component: <Login />
  },
  {
    name: 'Authentication',
    route: `/*`,
    component: <Navigate to="login" />
  }
];
